<template>
  <nav class="navbar sticky-top navbar-light bg-light">
    <a href="/" class="navbar-brand">
      <img src="../assets/hs_logo.svg" height="60" alt="logo" />
    </a>
    <a class="call-btn" href="tel:01475-785017" @click="handleCallClick">
      <span class="d-md-none">
        <i class="mobile-call-btn fas fa-phone-alt"></i> Call Now
      </span>
      <span class="d-none d-md-block">
        <i class="desktop-call-btn fas fa-phone-alt"></i> 01475 785017
      </span>
    </a>
  </nav>
</template>

<script>
import { mixpanel } from "../main";

export default {
  name: "AppHeader",
  methods: {
    handleCallClick() {
      mixpanel.track("Call Now Button Click");
    }
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.navbar {
  height: 5em;
  z-index: 100;
}

.call-btn {
  background-color: green;
  color: white;
  --height: 2.5em;
  height: 2.5em;
  width: auto;
  border-width: 0.1em;
  padding: 0.5em 1.5em 0.5em;
  /* padding-left: 1.5em;
  padding-right: 1.5em; */
  border-color: white;
  border-radius: calc(var(--height) / 2);
  text-align: center;
  vertical-align: middle;
  font-weight: 500;
  cursor: pointer;
}

.call-btn:hover {
  background-color: rgb(0, 182, 0);
}
</style>
